module.exports = __webpack_public_path__ + "static/media/step1.5910ba35.png";